package com.milta.core.localization.translations.fr

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Chargement…",
    errorNoConnection = "Impossible de contacter le serveur — vérifie ta connexion.",
    errorGeneric = "Une erreur est survenue. Réessaie plus tard.",
    contractLockedNotice = "🔒 Le contrat de sortie (format JSON) reste verrouillé — il est ajouté automatiquement côté serveur après le texte édité, pour ne jamais casser l'extraction en production.",
    notModifiedLabel = "Valeur par défaut — jamais modifié",
    modifiedOnPrefix = "Modifié le",
    resetToDefaultAction = "↺ Réinitialiser aux valeurs par défaut",
    editableBodyLabel = "✏️ Corps éditable — règles métier",
    markdownBoldSnippet = "**texte en gras**",
    markdownItalicSnippet = "*texte en italique*",
    markdownCodeSnippet = "`code`",
    markdownHeadingSnippet = "## Titre",
    markdownBulletSnippet = "- élément de liste",
    markdownNumberedSnippet = "1. élément de liste",
    markdownQuoteSnippet = "> citation",
    previewToggleEdit = "✏️ Modifier",
    previewToggleShow = "👁 Aperçu",
    contractFooterLabel = "🔒 Contrat de sortie — verrouillé, ajouté automatiquement",
    actionErrorOffline = "Échec — vérifie ta connexion.",
    actionErrorGeneric = "Échec de l'enregistrement, réessaie.",
    unsavedChangesNotice = "● Modifications non enregistrées",
    savingAction = "Enregistrement…",
    saveAction = "Enregistrer les modifications",
)
